import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Skeleton,
  Box,
} from "@mui/material";

const TableSkeleton = ({ columns, filterManager, skeletonRows = 2 }) => {
  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <Table
        sx={{
          tableLayout: "fixed !important",
          width: "100%",
          minWidth: "100%",
          maxWidth: "100%",
        }}
      >
        <colgroup>
          {columns.map((column, index) => (
            <col
              key={index}
              style={{
                width: column.width || "auto",
                minWidth: column.width || "auto",
                maxWidth: column.width || "auto",
              }}
            />
          ))}
        </colgroup>
        <TableHead>
          <TableRow>
            {columns.map((column, colIndex) => (
              <TableCell
                key={colIndex}
                align={column.align || "left"}
                sx={{
                  backgroundColor: "#F7F7FC",
                  textAlign: column.align || "left",
                  width: column.width ? `${column.width} !important` : "auto",
                  minWidth: column.width
                    ? `${column.width} !important`
                    : "auto",
                  maxWidth: column.width
                    ? `${column.width} !important`
                    : "auto",
                  padding: "16px",
                  verticalAlign: "middle",
                }}
              >
                <Skeleton variant="text" height={24} width="60%" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: skeletonRows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((column, colIndex) => (
                <TableCell
                  key={colIndex}
                  align={column.align || "left"}
                  sx={{
                    textAlign: column.align || "left",
                    width: column.width ? `${column.width} !important` : "auto",
                    minWidth: column.width
                      ? `${column.width} !important`
                      : "auto",
                    maxWidth: column.width
                      ? `${column.width} !important`
                      : "auto",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Skeleton variant="text" height={30} width="100%" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default TableSkeleton;
